import React from 'react'
import './Random.css'

export default function Portfolio() {
  return (
    <>
      <div className='random_div'>
      <h2>THis is the Portfolio Page.</h2>
      </div>
    </>
  )
}
